module.exports = __webpack_public_path__ + "img/close_icon.0c57efc8.svg";